import { API_BASE } from "@/lib/apiClient";
import { isElectronLoginRuntime } from "@/lib/electron";
import { resolvePostLoginHomeFromLoginPage } from "@/lib/designPreview";

export const ENTRA_LOGIN_ERRORS: Record<string, string> = {
  entra_auth_failed: "Anmeldung über Microsoft fehlgeschlagen.",
  entra_missing_code: "Antwort von Microsoft unvollständig. Bitte erneut versuchen.",
  entra_state_mismatch: "Sitzung ungültig. Bitte erneut anmelden.",
  entra_pkce_missing: "Sitzung ungültig. Bitte erneut anmelden.",
  entra_callback_failed: "Anmeldung konnte nicht abgeschlossen werden.",
  entra_not_app_user:
    "Kein Zugriff: Dein Konto ist nicht in der Gruppe „App-Nutzer“.",
};

export { isElectronLoginRuntime } from "@/lib/electron";

function resolveEntraNextUrl(postLoginTarget: string): string {
  const raw = String(postLoginTarget || "").trim();
  if (!raw) {
    return `${window.location.origin}${resolvePostLoginHomeFromLoginPage()}`;
  }
  // Bereits absolute Ziel-URL (https://… oder Native-Scheme) nicht erneut mit origin prefixen.
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) {
    return raw;
  }
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  return `${window.location.origin}${path}`;
}

export function buildEntraStartUrl(
  postLoginTarget: string = resolvePostLoginHomeFromLoginPage(),
): string {
  const nextUrl = isElectronLoginRuntime()
    ? "ernsthaus-auth://callback"
    : resolveEntraNextUrl(postLoginTarget);
  const apiBase = API_BASE || "";
  return `${apiBase}/auth/entra/start?next=${encodeURIComponent(nextUrl)}`;
}

export function parseEntraLoginError(search: string): string | null {
  const error = new URLSearchParams(search).get("error");
  if (!error) return null;
  return ENTRA_LOGIN_ERRORS[error] ?? "Anmeldung fehlgeschlagen.";
}

export async function checkAuthenticated(): Promise<boolean> {
  if (!API_BASE) return false;
  try {
    const res = await fetch(`${API_BASE}/me`, {
      credentials: "include",
      cache: "no-store",
    });
    if (!res.ok) return false;
    const data = (await res.json().catch(() => ({}))) as { username?: string };
    return Boolean(data?.username);
  } catch {
    return false;
  }
}
